import React from 'react'
import { Link, NavLink } from 'react-router-dom'
import { keycloak, loggedInUserHasRole } from '../lib'
import { LogoutIcon } from './icons'
import tomraArrow from '../images/misc/tomraArrow.png'
import { AppMenuMountDiv } from './AppMenuMountDiv'

export const Header = () => {
  const hasStatisticsSearchRole = loggedInUserHasRole('VOUCHER_CONTROL_ADMIN_STATISTICS_SEARCH')
  const hasUserAdminRole = loggedInUserHasRole('VOUCHER_CONTROL_ADMIN_MANAGE_SOAP_CLIENTS')
  const showNavBar = hasStatisticsSearchRole || hasUserAdminRole

  return (
    <div className="navbar">
      <div className="w-full max-w-screen-2xl mx-auto grid grid-cols-12 gap-md">
        <Link to="/search" className="flex items-center col-span-3">
          <img src={tomraArrow} className="h-xl mr-md" alt="TOMRA logo" />
          <span className="text-white">Voucher Manager</span>
        </Link>

        {showNavBar && (
          <>
            <NavLink className="navtab col-span-2" to="/search">
              Search
            </NavLink>

            {hasStatisticsSearchRole && (
              <NavLink className="navtab col-span-2" to="/statistics">
                Statistics
              </NavLink>
            )}

            {hasUserAdminRole && (
              <NavLink className="navtab col-span-2" to="/users">
                Users
              </NavLink>
            )}
          </>
        )}

        <div className="col-span-3 col-start-10 flex justify-end items-center space-x-md">
          <AppMenuMountDiv />

          <button className="btn btn-icon" aria-label="Log out" onClick={() => keycloak.logout()}>
            <LogoutIcon width="2rem" height="2rem" color="white" />
          </button>
        </div>
      </div>
    </div>
  )
}
